import React from 'react';
import ProductCard from '../components/ProductCard';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const products = [
 {
    id: 100,
    title: "Chicken Boneless Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1200,
    imageMain: "./assets/Chicken Boneless Pickle.png",
    images: [
      "./assets/chicken/chicken-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
 {
    id: 1,
    title: 'Mango Pickle (Avakaya)',
    description: 'Homemade Famous Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/101 – Mango Pickle (Avakaya).jpg',
    images: [
      "./assets/mango/1-1kg.jpg",
      "./assets/mango/mango-2.jpg",
      "./assets/mango/mango-250.jpg"
    ]
  },
 {
    id: 1,
    title: 'Wholesale Enquiry',
    description: '📞 Contact us today for our latest wholesale price list',
    price: 0,
    imageMain: './assets/1 Wholesale Prices.jpg',
    images: [
      "./assets/mango/1-1kg.jpg",
      "./assets/mango/mango-2.jpg",
      "./assets/mango/mango-250.jpg"
    ]
  },
 {
    id: 1,
    title: 'Door Delivery Enquiries',
    description: '📞 Contact us today for Door Delivery Enquiry and place your order.',
    price: 0,
    imageMain: './assets/1 Door Delivery.jpg',
    images: [
      "./assets/mango/1-1kg.jpg",
      "./assets/mango/mango-2.jpg",
      "./assets/mango/mango-250.jpg"
    ]
  },
  {
    id: 101,
    title: "Chicken Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 800,
    imageMain: "./assets/Chicken Pickle.jpg",
    images: [
      "./assets/Chicken Pickle.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 102,
    title: "Prawn Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1600,
    imageMain: "./assets/Prawn Pickle.jpg",
    images: [
      "./assets/prawn/prawn-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
     {
    id: 2,
    title: 'Tomato Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/102 – Tomato Pickle.jpg',
    images: [
      './assets/pandumirapa/pandumirapa-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 3,
    title: 'Gongura Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/103 – Gongura Pickle.jpg',
    images: [
      './assets/tomato/tomato-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 4,
    title: 'Red Chilli Pickle (Pandu Mirapa Pickle)',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/104 – Red Chilli Pickle (Pandu Mirapa Pickle).jpg',
    images: [
      './assets/lemon/lemon-2.jpg',
      './assets/lemon/lemon-1.jpg',
      './assets/lemon/lemon-2.jpg',
    ],
  },
  {
    id: 5,
    title: 'Bitter Gourd Pickle (Kakarakaya Pickle)',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/105 – Bitter Gourd Pickle (Kakarakaya Pickle).jpg',
    images: [
      './assets/allam/allam-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 6,
    title: 'Amla Pickle (Indian Gooseberry)',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/106 – Amla Pickle (Indian Gooseberry).jpg',
    images: [
      './assets/gongura/gongura-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
   {
    id: 1,
    title: 'Ginger Pickle (Allam Pickle)',
    description: 'Homemade Famous Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/107 – Ginger Pickle (Allam Pickle).jpg',
    images: [
      "./assets/mango/1-1kg.jpg",
      "./assets/mango/mango-2.jpg",
      "./assets/mango/mango-250.jpg"
    ]
  },
  {
    id: 2,
    title: 'Carrot Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/108 – Carrot Pickle.jpg',
    images: [
      './assets/pandumirapa/pandumirapa-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 3,
    title: 'Lemon Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/109 – Lemon Pickle.jpg',
    images: [
      './assets/tomato/tomato-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 4,
    title: 'Brinjal Pickle (Vankaya Pickle)',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/110 – Brinjal Pickle (Vankaya Pickle).jpg',
    images: [
      './assets/lemon/lemon-2.jpg',
      './assets/lemon/lemon-1.jpg',
      './assets/lemon/lemon-2.jpg',
    ],
  },
  {
    id: 5,
    title: 'Tamarind Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/111 – Tamarind Pickle.jpg',
    images: [
      './assets/allam/allam-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 6,
    title: 'Drumstick Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/112 – Drumstick Pickle.jpg',
    images: [
      './assets/gongura/gongura-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
   {
    id: 1,
    title: 'Ivy Gourd Pickle',
    description: 'Homemade Famous Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/113 – Ivy Gourd Pickle.jpg',
    images: [
      "./assets/mango/1-1kg.jpg",
      "./assets/mango/mango-2.jpg",
      "./assets/mango/mango-250.jpg"
    ]
  },
  {
    id: 2,
    title: 'Magaya Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/114 – Magaya Pickle.jpg',
    images: [
      './assets/pandumirapa/pandumirapa-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 3,
    title: 'Grated Mango Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/115 – Grated Mango Pickle.jpg',
    images: [
      './assets/tomato/tomato-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 4,
    title: 'Kothimeera Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/116 – Kothimeera Pickle.jpg',
    images: [
      './assets/lemon/lemon-2.jpg',
      './assets/lemon/lemon-1.jpg',
      './assets/lemon/lemon-2.jpg',
    ],
  },
  {
    id: 5,
    title: 'Mint Pickle (Pudina Pickle)',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/117 – Mint Pickle (Pudina Pickle).jpg',
    images: [
      './assets/allam/allam-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 6,
    title: 'Mango Chips Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/118 – Mango Chips Pickle.jpg',
    images: [
      './assets/gongura/gongura-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
   {
    id: 1,
    title: 'Cauliflower Pickle',
    description: 'Homemade Famous Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/119 – Cauliflower Pickle.jpg',
    images: [
      "./assets/mango/1-1kg.jpg",
      "./assets/mango/mango-2.jpg",
      "./assets/mango/mango-250.jpg"
    ]
  },
  {
    id: 2,
    title: 'Garlic Pickle (Vellulli Pickle)',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 500,
    imageMain: './assets/120 – Garlic Pickle (Vellulli Pickle).jpg',
    images: [
      './assets/pandumirapa/pandumirapa-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 3,
    title: 'Mixed Veg Pickle',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 500,
    imageMain: './assets/121 – Mixed Veg Pickle.jpg',
    images: [
      './assets/tomato/tomato-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 4,
    title: 'Dried Salted Chillis',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 600,
    imageMain: './assets/122 – Dried Salted Chillis.jpg',
    images: [
      './assets/lemon/lemon-2.jpg',
      './assets/lemon/lemon-1.jpg',
      './assets/lemon/lemon-2.jpg',
    ],
  },
  {
    id: 5,
    title: 'Pulihara Paste',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 600,
    imageMain: './assets/123 – Pulihara Paste.jpg',
    images: [
      './assets/allam/allam-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 103,
    title: "Gongura Chicken Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1000,
    imageMain: "./assets/Gongura Chicken Pickle.jpg",
    images: [
      "./assets/chicken/chicken-2.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 104,
    title: "Gongura Chicken Boneless Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1400,
    imageMain: "./assets/Gongura Chicken Boneless Pickle.jpg",
    images: [
      "./assets/chicken/chicken-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 105,
    title: "Fish Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1600,
    imageMain: "./assets/Fish Pickle.jpg",
    images: [
      "./assets/fish/fish-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 106,
    title: "Mutton Boneless Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 2500,
    imageMain: "./assets/Mutton Boneless Pickle.jpg",
    images: [
      "./assets/mutton/mutton-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 1,
    title: 'Mango',
    description: 'Homemade Famous Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/mango/mango-1.jpg',
    images: [
      "./assets/mango/1-1kg.jpg",
      "./assets/mango/mango-2.jpg",
      "./assets/mango/mango-250.jpg"
    ]
  },
  {
    id: 4,
    title: 'Lemon',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/lemon/lemon-1.jpg',
    images: [
      './assets/lemon/lemon-2.jpg',
      './assets/lemon/lemon-1.jpg',
      './assets/lemon/lemon-2.jpg',
    ],
  },
  {
    id: 5,
    title: 'Allam',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/allam/allam-1.jpg',
    images: [
      './assets/allam/allam-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 6,
    title: 'Gongura',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/gongura/gongura-1.jpg',
    images: [
      './assets/gongura/gongura-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 7,
    title: 'Munaga',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/munaga/munaga-1.jpg',
    images: [
      './assets/munaga/munaga-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 8,
    title: 'Kakara',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/kakara/kakara-1.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 9,
    title: 'Dondakaya',
    description: 'Homemade Trendy Pickle - 1Kg',
    price: 300,
    imageMain: './assets/donda/donda-1.jpg',
    images: [
      './assets/donda/donda-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 10,
    title: 'Chicken',
    description: 'Homemade Trendy Pickle - 250gm',
    price: 200,
    imageMain: './assets/chicken/chicken-1.jpg',
    images: [
      './assets/chicken/chicken-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 11,
    title: 'Prawn',
    description: 'Homemade Trendy Pickle - 250gm',
    price: 400,
    imageMain: './assets/prawn/prawn-1.jpg',
    images: [
      './assets/prawn/prawn-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 12,
    title: 'Fish',
    description: 'Homemade Trendy Pickle - 250gm',
    price: 400,
    imageMain: './assets/fish/fish-1.jpg',
    images: [
      './assets/fish/fish-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 13,
    title: 'Chicken SP',
    description: 'Homemade Trendy Pickle - 250gm',
    price: 300,
    imageMain: './assets/chicken/chicken-2.jpg',
    images: [
      './assets/chicken/chicken-2.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
    {
    id: 14,
    title: 'Bitter Gourd Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Bitter Gourd Karam Podi.jpg',
    images: [
      "./assets/mango/1-1kg.jpg",
      "./assets/mango/mango-2.jpg",
      "./assets/mango/mango-250.jpg"
    ]
  },
  {
    id: 15,
    title: 'Coconut Karam Podi.jpg',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Coconut Karam Podi.jpg',
    images: [
      './assets/pandumirapa/pandumirapa-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 16,
    title: 'Coriander Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Coriander Karam Podi.jpg',
    images: [
      './assets/tomato/tomato-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 17,
    title: 'Curry Leaves Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Curry Leaves Karam Podi.jpg',
    images: [
      './assets/lemon/lemon-2.jpg',
      './assets/lemon/lemon-1.jpg',
      './assets/lemon/lemon-2.jpg',
    ],
  },
  {
    id: 18,
    title: 'Garlic Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Garlic Karam Podi.jpg',
    images: [
      './assets/allam/allam-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 19,
    title: 'Groundnut Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Groundnut Karam Podi.jpg',
    images: [
      './assets/gongura/gongura-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 20,
    title: 'Idli Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Idli Karam Podi.jpg',
    images: [
      './assets/munaga/munaga-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 21,
    title: 'Kandi Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Kandi Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  },
  {
    id: 22,
    title: 'Kothimeera Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Kothimeera Karam Podi.jpg',
    images: [
      './assets/donda/donda-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
     },
  {
    id: 23,
    title: 'Masala Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Masala Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
     },
  {
    id: 24,
    title: 'Munagaku Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Munagaku Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
     },
  {
    id: 25,
    title: 'Nalla Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Nalla Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
       },
  {
    id: 26,
    title: 'Nuvvula Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Nuvvula Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
     },
  {
    id: 27,
    title: 'Prawn Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 1000,
    imageMain: './assets/Prawn Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
   },
  {
    id: 28,
    title: 'Pudina Karam Podi',
    description: 'Homemade Famous Chilli powder - 1Kg',
    price: 600,
    imageMain: './assets/Pudina Karam Podi.jpg',
    images: [
      './assets/kakara/kakara-1.jpg',
      'image2.jpg',
      'image3.jpg',
    ],
  }
  // ... more products
];

function ProductMenuPage() {
  return (
    <Container className='mt-4 mb-4'>
      <Row>
        {products.map((product, index) => (
          <Col md={4} key={index} className='mt-4 mb-4'>
            {/* <Link to={`/product/${product.id}`}> */}
            <ProductCard product={product} />
            {/* </Link> */}
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default ProductMenuPage;
